import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { MatIcon } from '@angular/material/icon';

import { TextSeparatorComponent } from '@lib/shared-ui/commons/text-separator/text-separator.component';

import { TASK_DATA } from '../../../core/contracts/task-data.contract';
import { Task, TaskType } from '../../../core/models/task.interface';
import { TaskDataTargetComponent } from '../../commons/task-data-target/task-data-target.component';

@Component({
  selector: 'tasks-check-planned-appointment-task-summary',
  standalone: true,
  imports: [MatIcon, TaskDataTargetComponent, TextSeparatorComponent],
  template: `
    <div class="flex flex-col gap-1">
      <tasks-task-data-target (click)="navigateToMemberProfile()">
        <mat-icon icon>account_circle</mat-icon>
        <span text>{{ task.data.memberName }}</span>
      </tasks-task-data-target>
      <div class="flex items-center gap-2 text-neutral-500">
        <p class="font-bold">{{ task.data.partnerName }}</p>
        <shared-text-separator />
        <p>{{ task.data.doctorName }}</p>
        <shared-text-separator />
        <p>{{ task.data.serviceName }}</p>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckPlannedAppointmentTaskSummaryComponent {
  protected readonly router = inject(Router);
  protected readonly task = inject<Task<TaskType.CheckPlannedAppointment>>(TASK_DATA);

  protected navigateToMemberProfile(): void {
    this.router.navigate(['/members', this.task.data.memberId]);
  }
}
